// @flow

export const TYPE_RANGE = 'range';
export const TYPE_TERM = 'term';

export const facetMap = {
  bodywork: TYPE_TERM,
  make: TYPE_TERM,
  fueltype: TYPE_TERM,
  price: TYPE_RANGE,
  size: TYPE_TERM,
  transmission: TYPE_TERM,
  product_type: TYPE_TERM,
};

export default (Object.keys(facetMap): Array<$Keys<typeof facetMap>>);
